import { createLogger, globalThreshold, attachConsoleSink, exposeDevTools } from '@interlucent/logging';
import { registerVersion } from '@interlucent/global';

declare const __PKG_VERSION__: string;

// Attach console sink once at module load -- renders all interlucent:log events with styled output
attachConsoleSink(window);

// Expose DevTools namespace: interlucent.setLogLevel('debug'), interlucent.versions, etc.
exposeDevTools();
registerVersion('console', __PKG_VERSION__);

// Factory for console-app loggers (source = 'console')
export function logger(module: string) {
    return createLogger(window, 'console', module, globalThreshold('info'));
}
